/*
 * NOTE: This is an auto-generated file created by Iconic.
 *
 * You should not need to edit this file directly; if you need to add/remove any
 * icon modules, you can rebuild it by running `yarn icons:make`.
 */
import * as React from 'react'

import VacasaWrapper from '../Wrapper'

const VacasaCamera: React.FunctionComponent = () => {
  return (
    <VacasaWrapper id="camera" viewBox="0 0 14 14">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.2289 2.33301H12.25C13.2165 2.33301 14 3.11651 14 4.08301V10.4997C14 11.4662 13.2165 12.2497 12.25 12.2497H1.75C0.783502 12.2497 0 11.4662 0 10.4997V4.08301C0 3.11651 0.783502 2.33301 1.75 2.33301H3.77114L4.76464 0.842766C4.87283 0.680483 5.05496 0.583008 5.25 0.583008H8.75C8.94504 0.583008 9.12717 0.680483 9.23536 0.842766L10.2289 2.33301ZM5.56219 1.74967L4.5687 3.23992C4.46051 3.4022 4.27837 3.49967 4.08333 3.49967H1.75C1.42783 3.49967 1.16667 3.76084 1.16667 4.08301V10.4997C1.16667 10.8218 1.42783 11.083 1.75 11.083H12.25C12.5722 11.083 12.8333 10.8218 12.8333 10.4997V4.08301C12.8333 3.76084 12.5722 3.49967 12.25 3.49967H9.91667C9.72163 3.49967 9.53949 3.4022 9.4313 3.23992L8.43781 1.74967H5.56219ZM7 9.91634C5.38917 9.91634 4.08333 8.6105 4.08333 6.99967C4.08333 5.38884 5.38917 4.08301 7 4.08301C8.61083 4.08301 9.91667 5.38884 9.91667 6.99967C9.91667 8.6105 8.61083 9.91634 7 9.91634ZM7 8.74967C7.9665 8.74967 8.75 7.96617 8.75 6.99967C8.75 6.03318 7.9665 5.24967 7 5.24967C6.0335 5.24967 5.25 6.03318 5.25 6.99967C5.25 7.96617 6.0335 8.74967 7 8.74967Z"
        fill="currentColor"
      ></path>
    </VacasaWrapper>
  )
}

export default React.memo(VacasaCamera)
